import { type QueryOptions } from '@tanstack/query-core'

import { type DcEntity } from '@/libs/api'

import { fetchDc } from '../api'
import { dcsQueryKeys } from '../query-keys'

export const getDcQueryOptions = (
  tenantKey: string,
  dcId: number
): Required<Pick<QueryOptions<DcEntity>, 'queryKey' | 'queryFn'>> => {
  return {
    queryKey: dcsQueryKeys.detail(tenantKey, dcId),
    queryFn: async ({ signal }) => {
      return await fetchDc({ tenantKey, dcId }, signal)
    }
  }
}
